import React from 'react';
import { useI18n } from '@/i18n/I18nContext';
import { ABOUT } from '@/constants/testIds';

const ABOUT_IMG =
  'https://images.unsplash.com/photo-1688413399300-70f1cc8bb053?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzNTl8MHwxfHNlYXJjaHwzfHxzaGlwJTIwYnJpZGdlJTIwbmF2aWdhdGlvbnxlbnwwfHx8fDE3ODA5MDM3NDJ8MA&ixlib=rb-4.1.0&q=85&w=1400&h=1600';

export const About = () => {
  const { t } = useI18n();
  const chips = t('about.chips') || [];

  return (
    <section id="about" data-testid={ABOUT.root} className="relative py-24 sm:py-32 bg-[#050D17]">
      <div className="container mx-auto px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
          {/* Left: image with gold frame */}
          <div className="lg:col-span-5 relative">
            <div className="relative">
              <div className="absolute -top-3 -left-3 right-6 bottom-6 border border-[#C9A24E]/40 -z-0" aria-hidden="true" />
              <img
                src={ABOUT_IMG}
                alt="Ship bridge — navigation"
                className="relative w-full h-[520px] object-cover grayscale-[15%]"
                loading="lazy"
              />
              <div className="absolute -bottom-4 -right-4 bg-[#C9A24E] text-[#050D17] px-5 py-3 text-[10px] uppercase tracking-[0.28em] font-semibold">
                Worldwide Attendance
              </div>
            </div>
          </div>

          {/* Right: copy */}
          <div className="lg:col-span-7">
            <div className="flex items-center gap-3 mb-5">
              <span className="h-px w-10 bg-[#C9A24E]" />
              <span className="text-[11px] uppercase tracking-[0.32em] text-[#C9A24E]">
                {t('about.eyebrow')}
              </span>
            </div>

            <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl text-[#F2F5F8] leading-[1.1] max-w-xl">
              {t('about.title')}
            </h2>

            <div className="mt-8 space-y-5 text-[15px] leading-relaxed text-[#C9D2E2] max-w-2xl">
              <p>{t('about.body1')}</p>
              <p>{t('about.body2')}</p>
            </div>

            <div className="mt-8 flex flex-wrap gap-2.5">
              {chips.map((c) => (
                <span
                  key={c}
                  className="text-[11px] uppercase tracking-[0.22em] px-3 py-1.5 border border-[#C9A24E]/40 text-[#C9A24E]"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
